<template>
  <scroll-bar>
    <logo :class="{'collapse': isCollapse}"></logo>
    <el-menu
      mode="vertical"
      :unique-opened="true"
      :default-active="$route.path"
      :collapse="isCollapse"
      background-color="#304156"
      text-color="#fff"
      active-text-color="#409EFF"
      :collapse-transition="true"
    >
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </scroll-bar>
</template>

<script>
import Logo from '@/views/layout/components/Logo.vue'
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'
import variables from '@/styles/variables.scss'

export default {
  components: { SidebarItem, ScrollBar, Logo },
  props: {
    routes: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    ...mapGetters(['sidebar']),
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>

<style lang="less" scoped>
</style>
